import React from 'react';
import PropTypes from 'prop-types';
import { FDPaper } from '@facet-wealth/design';

export const SectionPaper = ({
  children,
  flex,
  height,
}) => {
  return (
    <FDPaper appearance={'elevated'} padding={1} flex={flex} height={height} overflow={'auto'}>
      {children}
    </FDPaper>
  );
};

SectionPaper.defaultProps = {
  flex: undefined,
  height: undefined,
};

SectionPaper.propTypes = {
  flex: PropTypes.number,
  height: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
